import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { MailInfo } from 'projects/app-misc/src/app/modules/email/data/mail-info';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { API_URL } from 'projects/core/src/public-api';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EmailService } from 'projects/app-misc/src/app/modules/email/data/email.service';
import { ProjectService } from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';
import { HttpClient } from '@angular/common/http';
import { OrdersService } from '../../data/orders.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-order-pdf-preview-dialog',
    templateUrl: './order-pdf-preview-dialog.component.html',
    styleUrls: ['./order-pdf-preview-dialog.component.scss']
})
export class OrderPdfPreviewDialogComponent implements OnInit {
    orderId: number;

    mailData: MailInfo;
    pdfLink: SafeUrl;
    googleLink: SafeUrl;

    dialogHeader: string;
    link: string;

    showLoadingSpinner = false;

    blobUrl: string;

    showSendButton = true;

    textAreaMessage: string;

    submitLoading: boolean;

    constructor(
        @Inject(API_URL) protected apiUrl: string,
        private snackBar: MatSnackBar,
        private ordersService: OrdersService,
        protected projectService: ProjectService,
        protected dialogRef: MatDialogRef<OrderPdfPreviewDialogComponent>,
        private http: HttpClient, // TODO MOVE TO SERVICE
        @Inject(MAT_DIALOG_DATA) private data: {
            orderId: number,
            dialogHeader: string,
            link: string,
            showSendButton: boolean;
        }
    ) {
        // this.dialogHeader = data.dialogHeader;

        this.link = data.link;
        this.orderId = data.orderId;

        this.showSendButton = data.showSendButton;


        const url = `${this.apiUrl}${this.link}`; // Or your url

        this.showLoadingSpinner = true;

        this.downloadFile(url).subscribe(
            (res) => {
                this.showLoadingSpinner = false;
                this.blobUrl = res;

            }
        );
    }

    private downloadFile(url: string): any {
        return this.http.get(url, { responseType: 'blob' })
            .pipe(
                map((result: any) => {
                    return result;
                })
            );
    }

    ngOnInit() {
        this.pdfLink = `${this.apiUrl}${this.link}`;
        this.ordersService.getOrderMessage(this.orderId).subscribe(msg => {
            this.textAreaMessage = msg.text

            if (msg.email) {
                this.dialogHeader = `${this.data.dialogHeader} ${msg.email}`
            }
            else {
                this.dialogHeader = this.data.dialogHeader
            }
        })
    }

    submitOrder() {
        this.submitLoading = true;

        this.ordersService.submitOrderWithMessage(this.orderId, this.textAreaMessage).subscribe(order => {
            this.openSnackBar('Success!', 'Success!')
            this.submitLoading = false;
            this.dialogRef.close(order);
        }, error => {
            this.openSnackBar(error.message, 'Error!');
            this.submitLoading = false;
        })
    }

    openSnackBar(message: string, type: string) {
        let panelClass = 'orders-snackbar';

        if (type === 'Error!') {
            panelClass = 'error-snackbar'
        }

        this.snackBar.open(message, '', {
            duration: 5000,
            panelClass,
            verticalPosition: 'top',
        });
    }

    closeDialog() {
        this.dialogRef.close('close-button');
    }
}
